import React, { Fragment } from "react";
import Leftpanel from "../../Layout/Sidebar/LeftPanel";
import NoRights from "../Common/NoRights";
import "./ChangeStyle.scss";
import { useSelector } from 'react-redux'
import StyleList from "./StyleList";


const UpdateStyle = () => {

    const { ReactBusinessId } = useSelector((state) => state.Business);

    return (
        <div className={ReactBusinessId <= 0 ? "all-content-container no-access-main-content-wrapper" : "all-content-container main-content-wrapper-template"}>
            <Leftpanel
                activatePage={"ChangeLayout"}
                activateTab={"GeneralSetting"}
            />
            {ReactBusinessId <= 0 || typeof ReactBusinessId === 'undefined' ?
                (
                    <Fragment>
                        <NoRights />
                    </Fragment>
                )
                :
                (
                    <div className="layout-panel-main-wrapper page-root flex-start change-theme-wrapper" style={{ display: "block" }}>
                        <Fragment>
                        <div id="updatestyleforpopup">
                        </div>
                            <StyleList updatelayout />                            
                        </Fragment>
                    </div>
                )
            }
        </div>
    )
}

export default UpdateStyle;